import { render, staticRenderFns } from "./postcode-modal.vue?vue&type=template&id=642574ce"
import script from "./postcode-modal.vue?vue&type=script&lang=js"
export * from "./postcode-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jackreeve/projects/logshed/wp-content/themes/logshed/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('642574ce')) {
      api.createRecord('642574ce', component.options)
    } else {
      api.reload('642574ce', component.options)
    }
    module.hot.accept("./postcode-modal.vue?vue&type=template&id=642574ce", function () {
      api.rerender('642574ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/components/postcode-modal.vue"
export default component.exports